<template>
  <div>
    <!-- <HotelHero class="hotellisthero"></HotelHero> -->
    <div class="position-relative" >
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3 text-white"><span v-if="cityNames != ''">Hotels in</span> {{cityNames}}</h1>

                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    @click="goback"
                    class="mb-3 mb-sm-0"
                    type="white"
                    icon="fa fa-chevron-left"
                  >Search Again</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>

    <!-- <cityselect class="hotelCitySelect"></cityselect> -->
    <!-- <HotelForm></HotelForm> -->
    <HotelListMiddle
      :cnames="cityNames"
      :cids="city"
      :cdates="dates"
      :cguests="guests"
      :ctravfor="travfor"
      :stars="stars"
      class="hotellistmiddle"
    ></HotelListMiddle>
  </div>
</template>
<script>
import BasicElements from "./components/BasicElements";
import HotelHero from "./components/HotelHero";
import Cityselect from "./components/CitySelect";
import HotelForm from "./components/HotelForm";
import HotelListMiddle from "./components/HotelsListMiddle";
import { APIURLS } from "../api/constants.js";

export default {
  name: "hotellist",
  components: {
    HotelHero,
    Cityselect,
    HotelForm,
    HotelListMiddle,
  },
  data() {
    return {
      city: "",
      cityNames: "",
      dates: "",
      guests: "",
      travfor: "",
      stars: "",
      
    };
  },
  methods: {
    goback() {
      this.$router.push("/");
    },
    getHotelsOLD() {
      
      // console.log("City: " + this.city);
      // console.log("CityNames: " + this.cityNames);
      // console.log("Dates: " + this.checkindate);
      // console.log("Guests: " + this.guests);
      // console.log("TravFor: " + this.travfor);
    },
  },
  created() {
    if (this.$route.query.city) {
      this.city = this.$route.query.city;
    }
    if (this.$route.query.cityNames) {
      this.cityNames = this.$route.query.cityNames;
    }
    if (this.$route.query.dates) {
      this.dates = this.$route.query.dates;
    }
    if (this.$route.query.guests) {
      this.guests = this.$route.query.guests;
    }
    if (this.$route.query.travfor) {
      this.travfor = this.$route.query.travfor;
    }
     if (this.$route.query.stars) {
      this.stars = this.$route.query.stars;
    }
    
    this.getHotelsOLD();
  },
};
</script>

<style scoped>
.hotellisthero {
  max-height: 30%;
}
.hotellistmiddle {
  margin-top: 0%;
}
.test {
  z-index: -1;
}
.hotelCitySelect {
  padding: 1em;
  background: #294b7585;
  border-radius: 1em;
  padding-top: 2em;
}
.hotelCitySelect p {
  color: #ffffff !important;
}
.selectCityLeadText {
  color: #ffffff !important;
}

/*---------------hotel-list---------------*/

.col-md-3 {
  flex: 0 0 23%;
}

.bglistcolor {
  width: 100%;
  background: #cfe9fc;
  background-repeat: no-repeat;
  background-image: linear-gradient(to bottom, #cfe9fc, #cfe9fc);
  padding: 50px;
  border-radius: 15px;
}
.flex-container {
  width: 95%;
}
.hotel-panel {
  border: 0.1rem solid #cccccc;
  border-radius: 5px;
  margin: 1rem;
  padding: 0.8rem 0.5rem;
}
.hotel-images img {
  width: 100%;
}
.svg-inline--fa.fa-w-18 {
  width: 1rem;
}

.box {
  border: 1px solid #cccccc;
  padding: 2rem 1rem;
}

.underline {
  margin: 0.5rem 0;
  border-bottom: 1px solid #cccccc;
}
.hotel-detail {
  padding-left: 2rem;
}
.hotel-panel > .col-md-2 {
  border: unset;
}
.color {
  color: #a52a2a;
}
.small {
  font-size: 0.9rem;
  line-height: 0.5;
}

.Scored {
  display: inline;
  padding: 0.5rem;
  background-color: #a52a2a;
  border-radius: 5px;
  color: #fff;
  margin-left: 2%;
}
.hotel-panel:hover {
  background-color: #008cff40;
  cursor: pointer;
}

.lastsection {
  margin-top: 5%;
}
@media (max-width: 769px) {
  .col-md-3 {
    flex: 100%;
  }
  .hotel-images img {
    width: 100%;
  }
  .navbar-toggler-icon{
    display:none;
  }
  
}
</style>